import { icons } from 'assets';
import Button from 'Components/shared/button';
import FormControl from 'Components/shared/control';
import Select from 'Components/shared/select';
import Text from 'Components/shared/text';
import Tooltip from 'Components/shared/tooltip';
import React from 'react'
import { useGetUsersBank } from 'services/accountsService';
import { copyTextToClipboard } from 'utils/stringServices';

import styles from '../wallet.module.css';

const Destination = ({values, handleUpdate,onNext}) => {
    const {data:userBanks, isLoading} = useGetUsersBank();
    const data = userBanks?.data || [];
   
    return(
        <div className={styles.Deposit}>
            <Text variant="lg" style={{fontWeight:"700"}} className="w-full">
            Which account do your want to send {values.amount || "₦0"}? 
            </Text>
            <div className={styles.Form}>
            <FormControl label="Select Bank" name="bank" id="bank">
                <Select fullWidth
                placeholder="Select Bank"
        
                value={values.bank}
                {...handleUpdate()}
                options={data}
                optionsText ={item => `${item.accountName} - ${item.bank} - ${item.accountNumber}`}
                optionsValue={item => item.id}
                />
            </FormControl>
            
            <FormControl style={{marginTop:"34px"}}>
                <Button onClick={onNext} disabled={isLoading || !values.bank} fullWidth>
                    Continue
                </Button>
            </FormControl>
            </div>
        </div>
    )
}



export default Destination;